import React, { Component } from 'react'
import Dialog from 'material-ui/Dialog'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

class Confirmation extends Component {

    static propTypes = {
        title: PropTypes.string,
        content: PropTypes.string.isRequired,
        confirm: PropTypes.func.isRequired,
        confirmLabel: PropTypes.string,
        cancel: PropTypes.func,
        cancelLabel: PropTypes.string,
    }

    state = {
        isOpened: true,
    }

    cancel = () => {
        this.setState({isOpened: false})

        if(typeof(this.props.cancel) === 'function')
        {
            this.props.cancel()
        }
    }

    render()
    {
        const { t, confirm, title, content, confirmLabel, cancelLabel } = this.props

        const actions = [
            <input
                type="button"
                className="btn primary"
                value={confirmLabel || t('visualizer:common.modal.buttons.confirm')}
                onClick={confirm}
            />,
            <input
                type="button"
                className="btn secondary"
                value={cancelLabel || t('visualizer:common.modal.buttons.cancel')}
                onClick={this.cancel}
            />
        ]

        return (
            <Dialog
                title={title}
                actions={actions}
                modal={true}
                autoScrollBodyContent={true}
                open={this.state.isOpened}
            >
                {content}
            </Dialog>
        );
    }
}

export default withTranslation()(Confirmation)
